import { ThemeUIStyleObject } from 'theme-ui';
import { CarrotTheme } from '..';

export const buttons: Record<string, ThemeUIStyleObject> = {
    default: {
        borderRadius: '20px',
        padding: '10px 32px',
        cursor: 'pointer',
        lineHeight: '20px',
        height: '40px',
        whiteSpace: 'nowrap',
        textAlign: 'center',
        fontSize: (theme: CarrotTheme) => theme.fontSizes.small,
        fontWeight: (theme: CarrotTheme) => theme.fontWeights.bold,
        fontFamily: (theme: CarrotTheme) => theme.fonts.gotham,
    },
    primary: {
        variant: 'buttons.default',
        backgroundColor: (theme: CarrotTheme) => theme.colors.carrotOrange,
        color: (theme: CarrotTheme) => theme.colors.white,
        border: 'none',
        ':hover': {
            backgroundColor: (theme: CarrotTheme) => theme.colors.darkCarrotOrange,
        },
        ':disabled': {
            backgroundColor: (theme: CarrotTheme) => theme.colors.gray,
            cursor: 'not-allowed',
        },
    },
    'primary-loading': {
        variant: 'buttons.primary',
        ':hover': {
            backgroundColor: (theme: CarrotTheme) => theme.colors.carrotOrange,
        },
        cursor: 'not-allowed',
    },
    secondary: {
        variant: 'buttons.default',
        backgroundColor: (theme: CarrotTheme) => theme.colors.white,
        border: (theme: CarrotTheme) => `2px solid ${theme.colors.carrotOrange}`,
        padding: '8px 30px',
        color: (theme: CarrotTheme) => theme.colors.black80,
        ':hover': {
            backgroundColor: (theme: CarrotTheme) => theme.colors.lightCarrotOrange,
        },
        ':disabled': {
            backgroundColor: (theme: CarrotTheme) => theme.colors.lightGrey,
            borderColor: (theme: CarrotTheme) => theme.colors.gray,
            color: (theme: CarrotTheme) => theme.colors.gray,
            cursor: 'not-allowed',
        },
    },
    'secondary-loading': {
        variant: 'buttons.secondary',
        ':hover': {
            backgroundColor: (theme: CarrotTheme) => theme.colors.white,
        },
        cursor: 'not-allowed',
    },
    alternate: {
        variant: 'buttons.default',
        backgroundColor: (theme: CarrotTheme) => theme.colors.white,
        color: (theme: CarrotTheme) => theme.colors.black80,
        border: 'none',
        ':hover': {
            backgroundColor: (theme: CarrotTheme) => theme.colors.lightCarrotOrange,
        },
        ':disabled': {
            backgroundColor: (theme: CarrotTheme) => theme.colors.gray,
            color: (theme: CarrotTheme) => theme.colors.white,
            cursor: 'not-allowed',
        },
    },
    'alternate-loading': {
        variant: 'buttons.alternate',
        ':hover': {
            backgroundColor: (theme: CarrotTheme) => theme.colors.white,
        },
        cursor: 'not-allowed',
    },
    icon: {
        default: {
            cursor: 'pointer',
            transition: 'opacity .15s ease-in',
            ':hover': {
                opacity: '0.5',
            },
            ':disabled': {
                opacity: '0.5',
                cursor: 'not-allowed',
            },
        },
    },
};
